import Block from '@/components/Block';
import styles from './style.module.less';
import clsx from 'clsx';
import { Image } from '@bfe/moly';
import {
  publicAssetsPath,
  thousandsSeparator,
  WalletType,
} from '@web3/base-utils';
import IconHot from '@/assets/svg/icon-hot.svg';
import { useFm, useScreenType, useToast } from '@web3/base-hooks';
import Line from '@/components/Line';
import { Button } from '@bfe/moly';
import { useConnectWalletModal } from '@web3fe/infra';
import useHomeStore from '@/store/home';
import { useMemo, useState } from 'react';
import { ClaimStatus, PointsType } from '@/types';
import { postClaimtTypePoints } from '@/services/home';
import { useWallet } from '@/hooks/wallet';
import { pointsTypes } from '@/config';
import { Page } from '@/config/track-config';

export const HotSwap = () => {
  const { isMobile } = useScreenType();
  const fm = useFm();
  const connectWallet = useConnectWalletModal();
  const { toastSuccess, toastFail, toastInfo } = useToast();
  const { supportWsotTask, walletId, walletType } = useWallet();
  const [loading, setLoading] = useState<boolean>(false);

  const {
    fetchWalletStat,
    fetchWalletTypePoints,
    fetchWalletTotalPoints,
    walletConfig,
    walletTypePoints,
  } = useHomeStore();

  const paramsBase = useMemo(
    () => ({
      walletId,
      walletType,
    }),
    [walletId, walletType]
  );
  const wsotPoints = useMemo(
    () => walletTypePoints.filter((item) => item.type === PointsType.wsot),
    [walletTypePoints]
  );
  const handleClick = async () => {
    if (!supportWsotTask) {
      connectWallet.show();
    } else if (wsotPoints[0].status !== 1) {
      toastInfo('没有可以领取的积分');
    } else {
      setLoading(true);
      const res = await postClaimtTypePoints({
        ...paramsBase,
        type: PointsType.wsot,
      });
      if (res.success) {
        toastSuccess(`Successful swap ${wsotPoints[0]?.unClaimPoint} points `);
        fetchWalletStat();
        fetchWalletTypePoints({
          ...paramsBase,
          type: walletType === WalletType.CLOUD ? PointsType.wsot : pointsTypes,
        });
        fetchWalletTotalPoints(paramsBase);
      } else {
        toastFail(res.message);
      }
      setLoading(false);
    }
  };
  return (
    <Block
      title={fm('wsotPointsExchange')}
      className=" mt-12"
      titleClass="!text-2xl"
    >
      <div className={clsx(styles['hot-swap-cont'], 'relative')}>
        <div
          className={clsx(
            styles['hot-swap-wrap'],
            'flex gap-4 justify-between items-center'
          )}
        >
          {/* <Image
          className={clsx('absolute -top-2 left-0 w-[682px] h-[114px]')}
          src={publicAssetsPath('/png/home/hotswap-bg.png')}
          alt="hotswap-bg"
        /> */}
          <div className="flex gap-6 items-center flex-1">
            <Image
              className="w-[88px] h-[88px]"
              src={publicAssetsPath('/png/home/hotswap-tip.png')}
              alt="hotswap-tip"
            />
            <div>
              <h3
                className={clsx(
                  'text-[#30CFBE] flex items-center font-semibold',
                  isMobile ? 'text-base' : 'text-2xl'
                )}
              >
                <Image
                  src={publicAssetsPath('/png/home/hotswap-wsot.png')}
                  alt=""
                  className={clsx(
                    isMobile ? 'w-[116px] h-6' : 'w-[144px] h-10'
                  )}
                />
                {fm('redemption')}
                <IconHot
                  className={clsx('ml-1', isMobile ? 'w-5 h-5' : 'w-6 h-6')}
                  viewBox="0 0 25 24"
                />
              </h3>
              <p
                className={clsx(
                  ' text-gray-t2 font-light text-left',
                  isMobile ? 'text-xs mt-3' : 'text-sm mt-2'
                )}
              >
                {fm('wsotToWeb3ExchangeRatio', {
                  wsotScale: walletConfig.wsotScale,
                })}
              </p>
            </div>
          </div>
          <div
            className={clsx(
              styles['hot-swap-ratio'],
              'flex gap-6 items-center justify-between'
            )}
          >
            <div className="flex flex-col w-1/2">
              <span className="label text-sm font-semibold">
                {fm('exchangeRatio')}
              </span>
              <span className="value text-3hxl font-semibold text-[#2ACABD]">
                {walletConfig.wsotScale ?? '--'}:1
              </span>
            </div>
            <Line height={48}></Line>
            <div className="flex flex-col w-1/2">
              <span className="label text-sm font-semibold">
                {fm('youHaveWsotPoints')}
              </span>
              <span className="value text-3hxl font-semibold text-[#2ACABD]">
                {!supportWsotTask
                  ? '--'
                  : thousandsSeparator(wsotPoints[0]?.wsotPoint)}
              </span>
            </div>
          </div>
          <Button
            variant={'primary'}
            size={isMobile ? 'small' : 'large'}
            className={clsx(
              isMobile ? 'text-sm !h-10' : 'text-lg w-60 h-14',
              'font-semibold mt-4' // bg-brand text-white
            )}
            data-spm-even="Web3UserClick"
            data-spm-data={JSON.stringify({
              page_name: Page.HomePage,
              button_name: 'Web3Points_SwapWSOT',
            })}
            loading={loading}
            disabled={
              supportWsotTask && wsotPoints[0]?.status !== ClaimStatus.yes
            }
            onClick={handleClick}
          >
            {fm(!supportWsotTask ? fm('checkMyPoints') : fm('redeemNow'))}
          </Button>
        </div>
      </div>
    </Block>
  );
};
